<template>
  <div
    id="book-details"
    class="safe-distance-top-header"
    :class="{ 'safe-distance-bottom-tool': !isShelves }"
  >
    <detail-header
      :pageTitle="goodss.goodsName"
      :shareInfo="shareInfo"
    ></detail-header>
    <!-- 是否下架 -->
    <Shelves v-if="isShelves" />
    <div v-else>
      <div>
        <!-- 页面滚动之后出现顶部导航  -->
        <anchor-scroll-nav
          v-if="tabsTitle.length > 1"
          :tabsTitleList="tabsTitle"
          anchorFlag=".anchor-box"
          faBoxId="book-details"
        ></anchor-scroll-nav>
        <!-- 1.顶部图片 100%宽 -->
        <div class="top-img" v-if="albumPicsList.length > 0">
          <van-swipe class="my-swipe" indicator-color="white">
            <van-swipe-item v-for="(item, index) in albumPicsList" :key="index">
              <img v-if="item != 'null'" v-lazy="$global.imgUrl + item" alt="" />
              <img v-else src="@/assets/img/mobile-img/zz_default.png" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="top-img" v-else>
          <img src="@/assets/img/mobile-img/zz_default.png" alt="" />
        </div>
        <!-- 2.主体内容 区域，统一设置边距-->
        <div class="content">
          <!-- 2.1图书基本信息（名称时间等） -->
          <div class="content-box meeting-info anchor-box" name="商品">
            <!-- 价格 -->
            <span class="price" v-show="minPrice === maxPrice"
              >¥{{ minPrice }}</span
            >
            <span class="price" v-show="minPrice !== maxPrice"
              >¥{{ minPrice }}-{{ maxPrice }}</span
            >
            <!-- 标题 商品名称 -->
            <h3 class="title">{{ goodss.goodsName }}</h3>
          </div>
          <!-- 2.2 图书详情 -->
          <div class="content-box detail-info anchor-box" name="详情">
            <h1>商品详情</h1>
            <!-- 基本信息 -->
            <div class="information">
              <h3>基本信息</h3>
              <span class="aaa"></span>
              <div class="table">
                <div class="column">
                  <p v-show="monographName"><span>书名</span></p>
                  <p v-show="isbn"><span>ISBN</span></p>
                  <p v-show="press"><span>出版社</span></p>
                  <p v-show="publishTime"><span>出版时间</span></p>
                  <p v-show="classifyNumber"><span>分类号</span></p>
                  <p v-show="authorName"><span>作者</span></p>
                  <p v-show="seriesTitle"><span>丛书名</span></p>
                  <p v-show="packageNumber"><span>包册数</span></p>
                  <p v-show="authorRegion"><span>作者地区</span></p>
                  <p v-show="translator"><span>译者</span></p>
                  <p v-show="compiler"><span>编者</span></p>
                  <p v-show="makePrice"><span>定价</span></p>
                  <p v-show="edition"><span>版次</span></p>
                  <p v-show="emboitementStatus"><span>是否套装</span></p>
                  <p v-show="pack"><span>包装</span></p>
                  <p v-show="bookCategory"><span>版别</span></p>
                  <p v-show="bookSize"><span>开本</span></p>
                  <p v-show="paperName"><span>用纸</span></p>
                  <p v-show="pageNumber"><span>页数</span></p>
                  <p v-show="monographLenght"><span>字数</span></p>
                </div>
                <div class="columns">
                  <p v-show="monographName">
                    <span>{{ monographName }}</span>
                  </p>
                  <p v-show="isbn">
                    <span>{{ isbn }}</span>
                  </p>
                  <p v-show="press">
                    <span>{{ press }}</span>
                  </p>
                  <p v-if="publishTime">
                    <span>{{ publishTime.substring(0, 7) }}</span>
                  </p>
                  <p v-show="classifyNumber">
                    <span>{{ classifyNumber }}</span>
                  </p>
                  <p v-show="authorName">
                    <span>{{ authorName }}</span>
                  </p>
                  <p v-show="seriesTitle">
                    <span>{{ seriesTitle }}</span>
                  </p>
                  <p v-show="packageNumber">
                    <span>{{ packageNumber }}</span>
                  </p>
                  <p v-show="authorRegion">
                    <span>{{ authorRegion }}</span>
                  </p>
                  <p v-show="translator">
                    <span>{{ translator }}</span>
                  </p>
                  <p v-show="compiler">
                    <span>{{ compiler }}</span>
                  </p>
                  <p v-show="makePrice">
                    <span>{{ makePrice }}</span>
                  </p>
                  <p v-show="edition">
                    <span>{{ edition }}</span>
                  </p>
                  <p v-show="emboitementStatus">
                    <span>{{ emboitementStatus === 0 ? "否" : "是" }}</span>
                  </p>
                  <p v-show="pack">
                    <span>{{ pack }}</span>
                  </p>
                  <p v-show="bookCategory">
                    <span>{{ bookCategory }}</span>
                  </p>
                  <p v-show="bookSize">
                    <span>{{ bookSize }}</span>
                  </p>
                  <p v-show="paperNames">
                    <span>{{ paperNames }}</span>
                  </p>
                  <p v-show="pageNumber">
                    <span>{{ pageNumber }}</span>
                  </p>
                  <p v-show="monographLenght">
                    <span>{{ monographLenght }}</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- 产品特色 -->
            <div class="characteristic" v-show="productFeature">
              <h3>产品特色</h3>
              <span class="aaa"></span>
              <div class="tect" v-html="productFeature"></div>
            </div>
            <!-- 编辑推荐 -->
            <div class="edit" v-show="editSuggest">
              <h3>编辑推荐</h3>
              <span class="aaa"></span>
              <div class="edit_text" v-html="editSuggest"></div>
            </div>
            <!-- 内容简介 -->
            <div class="validity" v-show="artSummary">
              <h3>内容简介</h3>
              <span class="aaa"></span>
              <div class="validity_text" v-html="artSummary"></div>
            </div>
            <!-- 作者简介 -->
            <div class="author" v-show="authorProfiles">
              <h3>作者简介</h3>
              <span class="aaa"></span>
              <div class="author_text" v-html="authorProfiles"></div>
            </div>
            <!-- 目录 -->
            <div class="directory" v-show="catalogue">
              <h3>目录</h3>
              <span class="aaa"></span>
              <div class="directory_text" v-html="catalogue"></div>
            </div>
            <!-- 前言 -->
            <div class="preface" v-show="preface">
              <h3>前言</h3>
              <span class="aaa"></span>
              <div class="preface_text" v-html="preface"></div>
            </div>
            <!-- 书评 -->
            <div class="bookreview" v-show="bookReview">
              <h3>书评</h3>
              <span class="aaa"></span>
              <div class="bookreview_text" v-html="bookReview"></div>
            </div>
          </div>
          <!-- 2.3 金融研修学院链接 -->
          <div class="content-box college-of-finance" @click="jump">
            <img
              v-if="business.headImg"
              :src="$global.imgUrl + business.headImg"
              alt=""
            />
            <img
              v-else
              src="../../../../assets/mylogin/default-JG.png"
              alt=""
            />
            <div class="businessName" v-html="business.name"></div>
            <button>查看</button>
          </div>
          <!-- 2.4 最新图书 -->
          <div
            v-if="booksList && booksList.length !== 0"
            class="uptodate anchor-box"
            name="推荐"
          >
            <div class="titles">
              <span class="titles_left"></span>最新图书<span
                class="titles_rignt"
              ></span>
            </div>
            <div>
              <div
                class="course_list"
                v-for="item in booksList"
                :key="item.id"
                @click="toBookDetails(item.id)"
              >
                <img
                  class="px-cover-img"
                  v-lazy="
                    item.albumPics
                      ? `${$global.imgUrl}${item.albumPics.split(',')[0]}`
                      : require('@/assets/img/mobile-img/zz_default.png')
                  "
                  alt=""
                />
                <div class="px-content">
                  <h5 class="px-title" v-html="item.goodsName"></h5>
                  <div class="px-info">
                    <div class="price">¥{{ item.goodsPrice[0] }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div v-else class="empty-data content-box">
              <img
                class="zanwu-img"
                src="@/assets/img//mobile-img/zanwu.png"
                alt=""
              />
              <p class="zanwu-text">暂无推荐</p>
            </div> -->
          </div>
        </div>
        <!-- 3.底部分享收藏点击报名 -->
        <footer-toolbar
          title="图书"
          :shareInfo="shareInfo"
          @sharePoster="sharePoster"
        >
          <!-- 分享面板右侧按钮 -->
          <template #right>
            <van-button v-if="isSale === 1" disabled type="info" :round="true">已停售</van-button>
            <van-button v-else type="info" :round="true" @click="meetingSignup"
              >立即购买</van-button
            >
          </template>
        </footer-toolbar>
        <!-- 4.sku面板 -->
        <goods-sku
          v-if="showSku"
          :showSku="showSku"
          :sku="sku"
          :goods="goods"
          :initial-sku="initialSku"
          buyText="立即购买"
          @handleBuy="signUp"
          @updateSkuPannelStatus="updateSkuPannelStatus"
        ></goods-sku>
      </div>
      <ExtendTool
        :hasExtend="hasExtend"
        :shareInfo="shareInfo"
        @sharePoster="(showStatus) => sharePoster(showStatus, true)"
      />
      <!-- 生成海报及海报分享 遮罩 -->
      <van-overlay
        class="poster-overlay"
        :lock-scroll="true"
        :show="showPoster"
        @click="restorePageScroll"
        @touchmove.prevent
        @mousewheel.prevent
      >
        <div class="wrapper">
          <div
            class="book-poster"
            style="
              width: 100vw;
              height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;

              position: relative;
            "
          >
            <img
              id="poster"
              v-if="posterUrl"
              width="315"
              height="467"
              ref="poster"
              :src="posterUrl"
              alt=""
              crossOrigin="anonymous"
            />
          </div>
        </div>

        <div
          class="poster-html"
          v-show="showPoster"
          style="opacity: 0; pointer-events: none"
        >
          <div class="book-poster">
            <div id="poster-dom">
              <div class="book-cover">
                <img
                  :src="
                    albumPicsList.length > 0
                      ? $global.imgUrl + albumPicsList[0]
                      : require('@/assets/img/mobile-img/zz_default.png')
                  "
                  alt=""
                />
              </div>
              <div class="book-info">
                <h1 class="book-title" v-html="tempTitle"></h1>
                <h2 class="book-price">
                  <span class="price" v-show="minPrice === maxPrice"
                    >¥{{ minPrice }}</span
                  >
                  <span class="price" v-show="minPrice !== maxPrice"
                    >¥{{ minPrice }}-{{ maxPrice }}</span
                  >
                </h2>
              </div>
              <div class="poster-bottom">
                <div class="qr-code-area">
                  <div ref="qrcode" id="qrcode"></div>
                  <span>长按识别二维码</span>
                </div>
                <img
                  src="@/assets/img/mobile-img/zw-logo.png"
                  alt=""
                  class="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else-if="title == '百科号' || title == '百家号' || title == '机构号'" id="poster-dom"></div> 
          </div> -->
      </van-overlay>
    </div>
  </div>
</template>

<script>
import DetailHeader from "@/views/mobileView/detail/components/detailHeader.vue";
import AnchorScrollNav from "@/views/mobileView/detail/components/anchorScrollNav.vue";
import FooterToolbar from "@/views/mobileView/detail/components/bottomTool.vue";
import ExtendTool from "@/views/mobileView/detail/components/extendTool.vue";
import GoodsSku from "@/views/mobileView/detail/components/goodsSku.vue";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import Shelves from "@/views/mobileView/detail/components/shelves.vue";
export default {
  name: "BookDetails",
  data() {
    return {
      // 确认订单参数
      confirmList: [],
      // 图片
      albumPics: "",
      // 图书名称
      monographName: "",
      isbn: "",
      // 出版社
      press: "",
      // 出版时间
      publishTime: "",
      // 分类号
      classifyNumber: "",

      // 最大价格
      maxPrice: "",
      // 最小价格
      minPrice: "",

      // 作者名称
      authorName: "",
      // 作者地区
      authorRegion: "",
      // 译者
      translator: "",
      // 编者
      compiler: "",
      // 定价
      makePrice: "",
      // 版次
      edition: "",
      // 是否套装
      emboitementStatus: "",
      // 丛书名
      seriesTitle: "",
      // 版别
      bookCategory: "",
      // 包装
      pack: "",
      // 包册数
      packageNumber: "",
      // 开本
      bookSize: "",
      // 用纸
      paperName: "",
      // 页数
      pageNumber: "",
      // 字数
      monographLenght: "",
      // 产品特色
      productFeature: "",
      // 编辑推荐
      editSuggest: "",
      // 内容简介
      artSummary: "",
      // 作者简介
      authorProfiles: "",
      // 目录
      catalogue: "",
      // 前言
      preface: "",
      // 书评
      bookReview: "",
      // 最新图书
      booksList: [],
      // 商家详情
      business: {},
      // 商家跳转需要参数
      userType: "",
      companyId: "",
      // 轮播图
      albumPicsList: [],
      showSku: false,
      tabsTitle: [
        {
          anchorName: "商品",
          active: true,
          // 必填
          show: true,
        },
        {
          anchorName: "详情",
          active: false,
          // 必填
          show: true,
        },
        {
          anchorName: "推荐",
          active: false,
          // 必填
          show: false,
        },
      ],
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
      },
      initialSku: {},
      goods: {
        // 默认商品 sku 缩略图
        picture: "",
      },
      // 商品相关
      goodsSkuInfosDto: {},
      goodss: {},
      shopsInfoDto: {},
      //联调
      information: {},
      shareInfo: {},
      // 如果当前详情接口返回指定code,标识下架
      isShelves: false,
      // 海报overlay
      showPoster: false,
      posterUrl: "",
      qrcode: null,
      // 海报模板中标题数据（如果涉及文本省略号，需JS处理，否则htmltocanvas无法显示省略号
      tempTitle: "",
      hasExtend: false,
      isSale: 0, // 是否停售 0 未停售，1 已停售
    };
  },
  components: {
    DetailHeader,
    AnchorScrollNav,
    FooterToolbar,
    ExtendTool,
    GoodsSku,
    Shelves,
  },
  created() {
    // 获取图书详情接口
    this.bookDetails();
  },
  methods: {
    meetingSignup() {
      // 判断当前用户是否登录，
      this.$preventFun.Debounce(() => {
        if (sessionStorage.getItem("token")) {
          this.showSku = true;
        } else {
          if (this.$route.query.out) {
            if (this.$global.isAndroid_ios()) {
              window.android.getToken();
            } else {
              window.webkit.messageHandlers.getToken.postMessage("null"); //ios
            }
          } else {
            // 如果未登录，跳转登录页
            // 记录源网页，登录成功之后跳转回当前页面
            this.$router.push("/logins");
          }
        }
      })();
    },
    // 获取图书详情接口
    async bookDetails() {
      const resp = await this.$apis.goodsServe.bookDetails({
        goodsId: this.$route.query.id || this.$route.query.goodsId,
        isFrontEnd: 1,
      });
      if (resp.resultCode == 200) {
        this.albumPics = resp.data.goodsDto[0].goods.albumPics;
        this.maxPrice = resp.data.maxPrice;
        this.minPrice = resp.data.minPrice;
        this.bookSize = resp.data.bookSize;
        this.packageNumber = resp.data.packageNumber;
        this.press = resp.data.press;
        this.publishTime = resp.data.publishTime;
        this.classifyNumber = resp.data.classifyNumber;
        this.authorRegion = resp.data.authorRegion;

        var authorNameArray = [];
        resp.data.articleAuthors.map((item) => {
          if (item.authorName.trim() != "") {
            authorNameArray.push(item.authorName);
          }
        });
        this.authorName = authorNameArray.join(",");

        var translatorArray = JSON.parse(resp.data.translator);
        translatorArray = translatorArray.filter((item) => {
          return item.trim() != "";
        });
        this.translator = translatorArray.join(",");
        if(resp.data.compiler) {
          var compilerArray = JSON.parse(resp.data.compiler);
          compilerArray = compilerArray.filter((item) => {
            return item.trim() != "";
          });
          this.compiler = compilerArray.join(",");
        }

        this.makePrice = resp.data.makePrice;
        this.edition = resp.data.edition;
        this.emboitementStatus = resp.data.emboitementStatus;
        this.pack = resp.data.pack;
        this.seriesTitle = resp.data.seriesTitle;
        this.bookCategory = resp.data.bookCategory;
        this.bookSize = resp.data.bookSize;
        this.monographLenght = resp.data.monographLenght;
        this.productFeature = resp.data.productFeature;
        this.editSuggest = resp.data.editSuggest;
        this.artSummary = resp.data.artSummary;
        this.authorProfiles = resp.data.authorProfiles;
        this.catalogue = resp.data.catalogue;
        this.preface = resp.data.preface;
        this.bookReview = resp.data.bookReview;
        this.booksList = resp.data.goodsDto[0].goodsList;
        if (this.booksList && this.booksList.length) {
          this.tabsTitle[2].show = true;
        }
        this.userType = resp.data.userType;
        this.companyId = resp.data.companyId;
        this.albumPicsList = resp.data.albumPics ? resp.data.albumPics : [];
        this.monographName = resp.data.monographName;
        this.isbn = resp.data.isbn;

        this.paperName = resp.data.paperName;
        this.pageNumber = resp.data.pageNumber;
        this.isSale = resp.data.goodsDto[0].isSale
        this.getUser(
          resp.data.userType,
          resp.data.createUser,
          resp.data.companyId
        );
        // 给APP分享需要的内容
        this.shareInfo = {
          title: resp.data.goodsDto[0].goods.goodsName,
          cover: resp.data.cover,
          artSummary: resp.data.artSummary,
          articleId: this.$route.query.id,
          articleType: 11,
          goodsId: this.$route.query.id,
          goodsTypeId: resp.data.goodsDto[0].goods.goodsTypeId,
          price: resp.data.minPrice == resp.data.maxPrice
              ? `${resp.data.minPrice}`
              : `${resp.data.minPrice}-${resp.data.maxPrice}`,
          saleType: resp.data.goodsDto[0].saleType,
        };
        this.$addStorageEvent(
          "isCollect",
          resp.data.goodsDto[0].collectState == 0
        );
        // 微信分享参数
        this.$global.toShare(
          resp.data.goodsDto[0].goods.goodsName,
          resp.data.artSummary,
          resp.data.cover
        );

        this.goodsSkuInfosDto = resp.data.goodsDto[0].goodsSkuInfosDto;
        this.goodss = resp.data.goodsDto[0].goods;
        this.shopsInfoDto = resp.data.goodsDto[0].shopsInfoDto;
        // 文章是否为可推广文章
        this.hasExtend = resp.data.goodsDto[0].goods.isPromotionGoods === 1;
        // 海报单行显示标题，htmltocanvas手动处理文本溢出省略号，暂时固定单行15个字显示
        this.tempTitle =
          this.goodss.goodsName.length > 15
            ? this.goodss.goodsName.substring(0, 16) + "..."
            : this.goodss.goodsName;
        if (resp.resultCode == 200) {
          // 处理sku数据格式
          var skuDataObj = this.$global.formatGoodsDataToVantSku(
            {
              goods: this.goodss,
              goodsList: this.booksList,
              goodsSkuInfosDto: this.goodsSkuInfosDto,
              shopsInfoDto: this.shopsInfoDto,
            },
            this.minPrice,
            this.maxPrice
          );
          this.sku = skuDataObj.sku;
          this.goods = skuDataObj.goods;
          this.initialSku = skuDataObj.initialSku;
        } else {
          this.$Message.warning(resultDesc);
        }
      } else if (
        resp.resultCode === "10401002" ||
        resp.resultCode === "10401001"
      ) {
        this.isShelves = true;
      } else {
        this.$Message.warning(resp.resultDesc);
      }
    },
    toBookDetails(id) {
      let out = this.$route.query.out;
      this.$router.push({
        name: "bookDetails",
        query: {
          id: id,
          out,
        },
      });
    },
    // 获取作者
    getUser(type, userId, companyId) {
      this.$apis.recomendServe
        .getAuthor({
          type,
          userId,
          companyId: companyId ? companyId : "",
        })
        .then((res) => {
          this.business = res.content;
        });
    },
    jump() {
      let out = this.$route.query.out;
      if (this.userType === 2) {
        this.$router.push({
          path: "/appusesjigou",
          query: {
            item: 2,
            id: this.companyId,
            out,
          },
        });
      } else if (this.userType === 1) {
        this.$router.push({
          path: "/appusesbaike",
          query: {
            item: 1,
            id: this.companyId,
            out,
          },
        });
      }
    },
    // 更新sku弹窗的显示状态
    updateSkuPannelStatus(status) {
      this.showSku = status;
    },
    signUp(skuData) {
      console.log(skuData, "hssdfj");
      var params = {};
      // 规格id
      params.id = skuData.selectedSkuComb.id;
      // 调取生成订单所需要的参数
      // params.id = "1679365056896307200";
      params.num = skuData.selectedNum;
      if (this.$route.query.promoterId) {
        params.promoterId = this.$route.query.promoterId;
      }
      this.confirmList.push(params);
      console.log(this.confirmList);
      // 跳转到确认订单页回显参数
      var information = {};
      information.selectedNum = skuData.selectedNum;
      information.pictureUrl = skuData.pictureUrl;
      information.selectedText = skuData.selectedText.replace("已选：", "");
      information.id = skuData.selectedSkuComb.id; // 规格id
      information.skuPrice = skuData.selectedSkuComb.skuPrice;
      information.monographName = this.monographName;
      information.shopsName = this.shopsInfoDto.shopsName;

      this.information = information;
      // 将所需要数据之后存储至localStorage （避免页面下一级页面所刷新导致数据丢失）
      localStorage.setItem("bookDetails", JSON.stringify(information));
      localStorage.setItem("bookParameter", JSON.stringify(this.confirmList));

      // 跟APP联调
      if (this.$route.query.out) {
        information.skuId = skuData.selectedSkuComb.id;

        information.goodsTitle = information.monographName;
        var appBookParams = {
          skuData: this.information,
          // 图书1
          type: 1,
        };
        if (this.$global.isAndroid_ios()) {
          window.android.confirmOrder(JSON.stringify(appBookParams));
        } else {
          window.webkit.messageHandlers.confirmOrder.postMessage(
            JSON.stringify(appBookParams)
          );
        }
      } else {
        // 跳转确认订单页
        this.$router.push({
          name: "bookConfirmOrder",
          params: information,
        });
      }
    },
    /* 海报内容相关 */
    // 海报分享
    sharePoster(showStatus, isExtend = false) {
      this.showPoster = showStatus;
      if (showStatus) {
        this.$nextTick(() => {
          this.drawPoster(isExtend);
        });
      }
    },

    // 二维码
    createQrCode(isExtend) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // 清空二维码,创建新的二维码
      this.qrcode = null;
      this.$refs["qrcode"].innerHTML = "";
      let text = `${location.href}${
        isExtend ? "&promoterId=" + userInfo.promoterId : ""
      }`;
      this.qrcode = new QRCode("qrcode", {
        width: 55 * 3,
        height: 55 * 3,
        text,
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    // html to canvas
    drawPoster(isExtend) {
      const _this = this;
      _this.createQrCode(isExtend);
      let scale = window.devicePixelRatio;
      html2canvas(document.querySelector("#poster-dom"), {
        useCORS: true,
        scrollY: 0,
        scrollX: 0,
        // width: 315,
        // height: 467,
        x: 0,
        y: 0,
        backgroundColor: "transparent",
        scale: scale ? scale : 1,
        windowWidth: Window.innerWidth,
        windowHeight: Window.innerHeight,
      }).then(function (canvas) {
        _this.posterUrl = canvas.toDataURL("image/png");
      });
    },
    // 关闭海报遮罩
    restorePageScroll() {
      this.showPoster = false;
      // 回到页面内，页面顶部导航栏状态恢复
      setTimeout(() => {
        this.$bus.$emit("posterVisibleStatus", this.showPoster);
      }, 500);
    },
  },
  computed: {
    // 用纸
    paperNames() {
      if (this.paperName === "1") {
        return "铜版纸";
      } else if (this.paperName === "2") {
        return "轻型纸";
      } else if (this.paperName === "3") {
        return "胶版纸";
      } else if (this.paperName === "4") {
        return "再生纸";
      } else if (this.paperName === "5") {
        return "硫酸纸";
      } else if (this.paperName === "6") {
        return "纯质纸";
      }
      return "";
    },
    // 出版时间
    formatPublishTime() {
      // var dateStr = this.publishTime;
      // dateStr = dateStr.substring(0, 7);
      // dateStr = dateStr.replace("-", "年")
      // dateStr = dateStr.replace("-", "月")
      // month = month < 10 ? "0" + month : "" + month;

      return this.publishTime.substring(0, 7);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";

.aaa {
  display: block;
  width: 63px;
  height: 7px;
  background: linear-gradient(270deg, #ffffff 0%, #4a79f1 100%);
  opacity: 0.5;
  margin: 0 auto;
}

#book-details {
  position: relative;
  background: #f5f5f5;
  // 底部分享栏固定在窗口底部
  // padding-bottom: 50px;
  // padding-top: 44px;

  // 下架样式
  .shelves-box {
    height: calc(100vh - 61px);
  }

  .top-img {
    width: 100%;
    height: 375px;

    .my-swipe .van-swipe-item {
      width: 100%;
      height: 375px;
      color: #fff;
      font-size: 20px;
      line-height: 150px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .content {
    padding: 12px;
    width: 100%;

    .content-box {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;

      h1 {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }

    .meeting-info {
      .price {
        font-size: 16px;
        color: #ff3d3d;
        line-height: 17px;
      }

      .title {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin: 12px 0;
      }
    }

    .detail-info {
      .detail-info-box {
        border-radius: 6px;
        margin-top: 16px;
        height: 437px;
        background: #d8d8d8;
      }

      .information {
        margin-top: 15px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          position: relative;
        }

        .table {
          display: flex;
          border: 1px #eee solid;
          border-radius: 5px;
          margin-top: 19px;

          .column {
            border: 1px #eee solid;
            flex-basis: 30%;

            p {
              border: 1px #eee solid;
              text-align: center;
              padding: 7px;
              color: #999999;
              height: 37px;
            }
          }
        }

        .columns {
          flex-basis: 70%;
          border: 1px #eee solid;

          p {
            border: 1px #eee solid;
            height: 37px;
            text-align: center;
            padding: 7px;
            color: #999999;

            span {
              display: inline-block;
              width: 200px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .characteristic {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .tect {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 17px;
        }
      }

      .edit {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .edit_text {
          margin-top: 10px;
        }
      }

      .validity {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .validity_text {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 10px;
        }
      }

      .author {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .author_text {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 10px;
        }
      }

      .directory {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .directory_text {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 10px;
        }
      }

      .preface {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .preface_text {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 10px;
        }
      }

      .bookreview {
        overflow: hidden;
        margin-top: 20px;

        h3 {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }

        .bookreview_text {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          margin-top: 10px;
        }
      }
    }

    .college-of-finance {
      display: flex;
      align-items: center;
      height: 70px;

      img {
        width: 50px;
        height: 47px;
      }

      .businessName {
        width: 210px;
        margin-left: 10px;
      }

      button {
        width: 60px;
        height: 30px;
        background: #4a79f1;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        border: 0;
      }
    }

    .uptodate {
      .titles {
        text-align: center;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
        margin-bottom: 8px;
        position: relative;

        .titles_left {
          display: block;
          width: 43px;
          height: 1px;
          border: 1px solid;
          border-image: linear-gradient(
              270deg,
              rgba(200, 200, 200, 1),
              rgba(255, 255, 255, 0)
            )
            1 1;
          position: absolute;
          top: 11px;
          left: 100px;
        }

        .titles_rignt {
          display: block;
          width: 43px;
          height: 1px;
          border: 1px solid;
          border-image: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0),
              rgba(200, 200, 200, 1)
            )
            1 1;
          position: absolute;
          top: 11px;
          right: 100px;
        }
      }

      .course_list {
        display: inline-block;
        margin: 12px 11px 0 0;
        padding: 10px;
        width: 170px;
        // height: 198px;
        border-radius: 6px;
        background-color: #fff;
        overflow: hidden;

        &:nth-child(2n) {
          // margin-left: 1px;
          margin-right: 0;
        }

        .px-cover-img {
          width: 100%;
          height: 170px;
          object-fit: contain;
          background-color: #fff;
        }

        .px-content {
          margin-top: 10px;
          // padding: 10px;
          // height: 100px;

          .px-title {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .px-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            .price {
              font-size: 15px;
              font-weight: 700;
              color: #ff0054;
            }

            .isSign {
              font-size: 11px;
              color: #999999;
            }
          }
        }
      }
    }
  }

  // 富文本回显，处理图片，表格，视频回显样式（表格浮动涉及溢出，图片视频涉及宽度调整）
  ::v-deep.validity_text,
  ::v-deep.directory_text,
  ::v-deep.tect,
  ::v-deep.edit_text,
  ::v-deep.author_text,
  ::v-deep.preface_text,
  ::v-deep.bookreview_text {
    overflow: hidden;

    img,
    video {
      max-width: 100% !important;
    }
  }

  .empty-data {
    text-align: center;

    .zanwu-img {
      width: 50%;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/styles/poster.scss";
</style>